// extracted by mini-css-extract-plugin
export default {"introPage":"DudaiqaCQjOhQZ6xR8Yg","inner":"MaJ5wm_XsoQAhfFI3p06","title":"kxiFQkmTCBqpAhuWz_ri","image":"zq2AAVNYSOLUevSNwJ2Z","name":"SYMamAoALojVwXaYjSRk"};